import { DetailTransactionType } from "sagas/types/detailTransactions";
import { ProofOfDeliveryRequiredType } from "./dniFinish/types";

function toArray(val: unknown, allowEmpty: boolean): unknown[] | null {
  if (Array.isArray(val)) return allowEmpty || val.length > 0 ? val : null;
  if (typeof val === "string" && val.trim() !== "") {
    try {
      const parsed = JSON.parse(val) as unknown;
      return Array.isArray(parsed) && (allowEmpty || parsed.length > 0) ? parsed : null;
    } catch {
      return null;
    }
  }
  return null;
}

function canonical(s: string): ProofOfDeliveryRequiredType {
  const u = s.toUpperCase().replace(/-/g, "_");
  if (u === "LASTNAME") return "LAST_NAME";
  if (u === "IDENTIFICATIONNUMBER") return "IDENTIFICATION_NUMBER";
  return u as ProofOfDeliveryRequiredType;
}

/**
 * Devuelve la lista de campos requeridos en proof of delivery.
 * Si el backend no envía ninguno, envía un array vacío.
 */
export function getProofOfDeliveryRequiredList(
  detailTransaction: DetailTransactionType | null | undefined
): ProofOfDeliveryRequiredType[] {
  const raw = getProofOfDeliveryRequiredListRaw(detailTransaction);
  if (raw.length > 0) return raw;
  return [];
}

/**
 * Lista tal como viene del backend (normalizada), sin default. Array vacío si no hay nada.
 */
export function getProofOfDeliveryRequiredListRaw(
  detailTransaction: DetailTransactionType | null | undefined
): ProofOfDeliveryRequiredType[] {
  if (!detailTransaction) return [];
  const tx = detailTransaction.transaction as Record<string, unknown> | undefined;
  const dt = detailTransaction as Record<string, unknown>;
  const sources: unknown[] = [
    tx?.proofOfDeliveryRequired,
    tx?.proof_of_delivery_required,
    detailTransaction?.proofOfDeliveryRequired,
    dt?.proof_of_delivery_required,
  ];
  const raw = sources
    .map((s) => toArray(s, true))
    .find((arr): arr is unknown[] => arr != null && arr.length >= 0);
  if (Array.isArray(raw)) {
    return raw.map((x: unknown) => canonical(String(x)));
  }
  return [];
}

export function requiresDeliveryEvidence(
  detailTransaction: DetailTransactionType | null | undefined
): boolean {
  const list = getProofOfDeliveryRequiredListRaw(detailTransaction);
  return list.length > 0 || detailTransaction?.transaction?.deliveryValidation?.type === "SERIAL_NUMBER";
}
